import {DropShadowFilter} from "@pixi/filter-drop-shadow";
import {Container} from "../core/Container";
import {Sprite} from "../core/Sprite";
import {Optionable} from "./Optionable";

export class PaperLayer extends Container implements Optionable {

    public isPaperLayer?: boolean;

    private readonly shadowBounds = new Sprite();

    constructor() {
        super();

        const dropShadow = new DropShadowFilter();
        this.filters = [dropShadow];

        this.addChild(this.shadowBounds);
        const p = 30;
        this.shadowBounds.width = 2730 + 2 * p;
        this.shadowBounds.height = 1536 + 2 * p;
        this.shadowBounds.x = -p;
        this.shadowBounds.y = -p;
    }

    public setVisible(value: boolean): void {
        this.visible = value;
    }

    public getVisible(): boolean {
        return this.visible;
    }

    public updateFilterScale(value: number) {
        const filter = this.filters![0] as DropShadowFilter;
        filter.blur *= value;
        filter.distance *= value;
    }
}
